// extracted by mini-css-extract-plugin
module.exports = {"type":"type_type__3xVws","size--small":"type_size--small__2JBQC","size--xs":"type_size--xs__3G7E0"};